/**
 * Content API - Detect and interact with current content
 * @module ContentAPI
 */

export class ContentAPI {
  /**
   * Detect current content from page context
   * @returns {Promise<object|null>} Content data or null
   */
  async detect() {
    try {
      const response = await fetch('/api/content/detect', {
        credentials: 'include'
      });
      
      if (!response.ok) {
        return null;
      }
      
      return await response.json();
    } catch (error) {
      console.warn('[ContentAPI] Could not detect content:', error);
      return null;
    }
  }

  /**
   * Get specific content by type and ID
   * @param {string} type - Content type (character, location, item, etc.)
   * @param {string} id - Content ID
   * @returns {Promise<object|null>} Content data
   */
  async get(type, id) {
    try {
      const response = await fetch(`/api/content/${type}/${id}`, {
        credentials: 'include'
      });
      
      if (!response.ok) {
        return null;
      }
      
      return await response.json();
    } catch (error) {
      console.error('[ContentAPI] Error fetching content:', error);
      return null;
    }
  }

  /**
   * Search content
   * @param {string} query - Search query
   * @param {object} options - Search options
   * @returns {Promise<array>} Search results
   */
  async search(query, options = {}) {
    try {
      const params = new URLSearchParams({
        q: query,
        ...options
      });

      const response = await fetch(`/api/content/search?${params}`, {
        credentials: 'include'
      });
      
      if (!response.ok) {
        return [];
      }
      
      const data = await response.json();
      return data.results || [];
    } catch (error) {
      console.error('[ContentAPI] Search error:', error);
      return [];
    }
  }
}
